import React from "react";
import Layout from "../../../../../../components/layouts/Layout";
import AddCareNotes from "../../../AddCareNotes";

function AddIndependentLivingOthers() {
  return (
    <>
      <Layout pageTitleText="Notes">
        <div className="incidents consentCapacityAddNew">
          <div className="mainContent ">
            <div className="mainContentText">
              <h3>Add Activities note</h3>
              <AddCareNotes noteType="Activities" parentListNoteUrl="/care-plan/general-notes" />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}


export default AddIndependentLivingOthers
